import styled, { keyframes } from "styled-components";
import { shade } from 'polished';

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  padding-bottom: 10px;
  justify-content: space-around;
  min-height: 683px;
  position: relative;
  overflow: hidden;

  & div.separator {
    background-color: ${shade(0, '#1B9EB2')};
    width: 10px;
    height: 100%;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 10px;

    @media (min-width: 1385px) {
      display: flex;
    }
  }

  @media (max-width: 1385px) {
    min-height: 600px;
  }

  @media (max-width: 1385px) {
    height: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;

    & div.separator {
      width: 100%;
      height: 10px;
    }
  }

  @media (max-width: 1385px) {
    padding-top: 50px;
  }

  @media (max-width: 768px) {
    overflow: auto;
    padding-top: 0;
  }
`;

export const Indicator = styled.div`
    min-width: 80%;
    margin: 0 auto;
    p {
      margin: 5px 0;
      color: #0c5c75;
      font-size: 0.9em;
    }
    .radio-label {  
      color:rgb(8, 68, 87);
      font-size: 0.9em;
    }

    @media (max-width: 768px) {
      min-width: 100%;
      height: auto;
      padding: 0 10px;
    }
`;

export const GoBack = styled.div`
  display: flex;
  animation: ${appear} 0.6s;
  margin: -10px 0 10px 0;

  & button {
    display: flex;
    align-items: center;
    background-color: transparent;
    color: #888888;

    & svg {
      font-size: 1.5em;
    }

    & p {
      font-size: 1em;
      font-weight: 500;
    }
  }
`;